import * as React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

const StyledUl = styled.ul`
  list-style-type: none;
  margin: 0;
`
const StyledLink = styled(Link)`
  color: #000;
  text-decoration: none;
`

const Office = () => (
  <li>
    <StyledLink to="/our-office">
      <strong>Our Office</strong>
    </StyledLink>
    <StyledUl>
      <li>
        <StyledLink to="/new-cosmetic-patient-forms">
          New Patient Forms
        </StyledLink>
      </li>
      <li>
        <StyledLink to="/our-office/meet-the-staff">Meet the Staff</StyledLink>
      </li>
      <li>
        <StyledLink to="/special-offers">Special Offers</StyledLink>
      </li>
      <li>
        <StyledLink to="/our-office/fees-financing">
          Fees &amp; Financing
        </StyledLink>
      </li>
    </StyledUl>
  </li>
)

export default Office
